import objectsList from './data/objectsList.json'
import {ru} from 'vuejs-datepicker/dist/locale'

export default {
  data () {
    return {
      ru: ru
    }
  },
  methods: {
    getObjectsListMix () {
      return Promise.resolve({data: objectsList})
    },
    getObjectsFullMix (id) {
      return Promise.resolve({data: require('./data/objectFull' + id)})
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/dataMix.js